import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useQueryParams } from './index';
import PropTypes from 'prop-types';
import cookieFactory from '../../cookieFactory';

export const UserUiConfigContext = React.createContext({
  userUiConfigState: {},
  setUserUiConfigState: () => {},
});

const setGridCookie = (val, path) => {
  const uiCookie = cookieFactory('ui-prod-grid-sort', { path: path, expires: 365 });
  if (uiCookie.get() !== val) {
    uiCookie.set(val);
  }
};

export const UserUiConfigProvider = ({ children }) => {
  const { params } = useQueryParams();
  const { pathname } = useLocation();
  const [userUiConfigState, setUserUiConfigState] = useState({
    productGridSort: params.uiProductGridSort || cookieFactory('ui-prod-grid-sort').get() || 'default',
  });

  if (params.uiProductGridSort) {
    setGridCookie(params.uiProductGridSort, pathname);
  }

  const setUserUiConfig = (newConfig) => {
    setUserUiConfigState({
      ...userUiConfigState,
      ...newConfig,
    });
    setGridCookie(newConfig.productGridSort);
  };

  return (
    <UserUiConfigContext.Provider value={{ userUiConfigState, setUserUiConfig }}>
      {children}
    </UserUiConfigContext.Provider>
  );
};

UserUiConfigProvider.propTypes = {
  children: PropTypes.node,
};
